import { NgModule } from '@angular/core';
import { MedicalFeeSearchComponent } from './medical-fee-search.component';
import { SharedModule } from '../../shared.module';
import { MedicalFeeFilterComponent } from '../medical-fee-filter/medical-fee-filter.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [
        MedicalFeeSearchComponent,
        MedicalFeeFilterComponent
    ],
    imports: [
        ReactiveFormsModule,
        SharedModule
    ],
    exports: [
    ]
  })
  export class MedicalFeeSearchModule { }
